// extracted by mini-css-extract-plugin
export var contentCol = "style-mod--content-col--64207";
export var contentTd = "style-mod--content-td--5e7e4";
export var contentsTable = "style-mod--contents-table--044ed";
export var description = "style-mod--description--79c79";
export var img = "style-mod--img--6ed70";
export var mainWrapper = "style-mod--main-wrapper--e1020";
export var tiContent = "style-mod--ti-content--00f65";
export var title = "style-mod--title--d0bd2";